import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useCallback } from 'react';
import { _Card, _CardHeading, _RequirementDescription } from "../style";
import { _Line, _GridContainer, _MoreQuestionsContainer, _MoreQuestionsText } from "./style";
import ExternalLinksAdditionalAttachments from "../Components/ExternalLinksAdditionalAttachments";
import useRequirementQuestions from "../../hooks/useRequirementQuestions";
import useExternalLinks from "../../hooks/useExternalLinks";
import useAdditionalAttachments from "../../hooks/useAdditionalAttachments";
import StudentRecordQuestion from "./StudentRecordQuestion";
import FontAwesome from 'react-fontawesome';
export default function QuestionRequirement(_ref) {
  var row = _ref.row,
    userIsOnMobile = _ref.userIsOnMobile;
  var questions = useRequirementQuestions(row.requirement.id);
  var SHOW_ALL_CUTOFF = 6;
  var SINGLE_COLUMN_CUTOFF = 3;
  var numHiddenQuestions = questions.length - SHOW_ALL_CUTOFF;
  var _useState = useState(questions.length <= SHOW_ALL_CUTOFF),
    _useState2 = _slicedToArray(_useState, 2),
    showAllQuestions = _useState2[0],
    setShowAllQuestions = _useState2[1];
  var hasLongAnswerQuestion = questions.find(function (question) {
    return question.attributes.question_format === 'long_answer';
  });
  var useTwoColumnDisplay = !hasLongAnswerQuestion && questions.length > SINGLE_COLUMN_CUTOFF && !userIsOnMobile;
  var externalLinks = useExternalLinks(row.requirement.id);
  var additionalAttachments = useAdditionalAttachments(row.requirement.id);
  var hasExternalLinkOrAdditionalAttachments = externalLinks.length > 0 || additionalAttachments.length > 0;
  var handleShowAllQuestions = useCallback(function () {
    return setShowAllQuestions(true);
  }, [setShowAllQuestions]);
  var questionList = showAllQuestions ? questions : questions.slice(0, SHOW_ALL_CUTOFF);
  return /*#__PURE__*/React.createElement(_Card, null, /*#__PURE__*/React.createElement(_CardHeading, null, row.requirement.title), /*#__PURE__*/React.createElement(_RequirementDescription, {
    dangerouslySetInnerHTML: {
      __html: row.requirement.description
    } // Descriptions can be HTML.
  }), hasExternalLinkOrAdditionalAttachments && /*#__PURE__*/React.createElement(ExternalLinksAdditionalAttachments, {
    externalLinks: externalLinks,
    additionalAttachments: additionalAttachments
  }), /*#__PURE__*/React.createElement(_GridContainer, {
    useTwoColumnDisplay: useTwoColumnDisplay
  }, questionList.map(function (question, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: question.id
    }, /*#__PURE__*/React.createElement(StudentRecordQuestion, {
      question: question
    }), index % 2 === 0 && /*#__PURE__*/React.createElement(_Line, null));
  })), !showAllQuestions && /*#__PURE__*/React.createElement(_MoreQuestionsContainer, {
    onClick: handleShowAllQuestions
  }, /*#__PURE__*/React.createElement(_MoreQuestionsText, null, numHiddenQuestions, " more", ' ', numHiddenQuestions === 1 ? 'question and answer' : 'questions and answers'), /*#__PURE__*/React.createElement(FontAwesome, {
    name: "angle-down",
    size: "2x"
  })));
}